import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import cls from 'classnames'
import { Controller, FieldErrors } from 'react-hook-form'

import InputText from '@/components/input-text'

import { AllNewReportForm } from '../../new-report-form-schema'
import { useNewReportForm } from '../../use-new-report-form'
import { useStyles } from './styles'

export function PeriodOptionsInput() {
  const classes = useStyles()

  const { control, register, formState, watch } = useNewReportForm()
  const errors = formState.errors as FieldErrors<AllNewReportForm>

  const period = watch('period.options')
  const disabled = period !== 'personalized'

  return (
    <Box className={cls(classes.formGroup, classes.border)}>
      <Typography variant='body1'>Escolha o período desejado:</Typography>
      <FormControl>
        <Controller
          name='period.options'
          control={control}
          defaultValue={'7'}
          render={({ field }) => (
            <RadioGroup {...field}>
              <FormControlLabel
                control={<Radio size='small' value='7' />}
                label={
                  <Typography variant='subtitle1'>Últimos 7 dias</Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='30' />}
                label={
                  <Typography variant='subtitle1'>Últimos 30 dias</Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='90' />}
                label={
                  <Typography variant='subtitle1'>Últimos 90 dias</Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='personalized' />}
                label={
                  <Typography variant='subtitle1'>Personalizado</Typography>
                }
              />
            </RadioGroup>
          )}
        />
      </FormControl>
      <Box display='flex'>
        <InputText
          id='period_personalized_start_date'
          label='De'
          type={'date'}
          {...register('period.personalized.start_date')}
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
          error={!!errors.period?.personalized?.start_date}
          helperText={errors.period?.personalized?.start_date?.message}
        />
        <InputText
          id='period_personalized_end_date'
          label='Até'
          type={'date'}
          {...register('period.personalized.end_date')}
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
          error={!!errors.period?.personalized?.end_date}
          helperText={errors.period?.personalized?.end_date?.message}
        />
      </Box>
    </Box>
  )
}
